export default __webpack_public_path__ + "static/media/deposit-icon.df93b961.webp";